exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-custom {\n    width: 100%;\n    position: fixed;\n    margin-bottom: 0px !important;\n    border-radius: 0px !important;\n    top: 40%;\n    z-index: 1002;\n    text-align: center;\n    font-weight: bold;\n    font-size: x-large;\n    background-color: #ffffff !important;\n    overflow: auto;\n    max-height: 60vh;\n}\n.alert {\n    border-color: unset !important;\n}\n.alert-message {\n    white-space: pre-line;\n}\n.close {\n    top: -12px !important;\n    right: -30px !important;\n    opacity: .9 !important;\n}\n.grey-layer {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    z-index: 1001;\n    background: rgba(134, 134, 134, 0.5);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/alert/alert.component.css
// module id = ../../../../../src/app/components/utilita/alert/alert.component.css
// module chunks = main